// @flow
import blue from '@material-ui/core/colors/blue';
import orange from '@material-ui/core/colors/orange';
import pink from '@material-ui/core/colors/pink';

import { APP_NAME, PRODUCT_NAME } from '../constants/enums';

const getTheme = () => {
  if (APP_NAME === PRODUCT_NAME.GENIEE) {
    return {
      palette: {
        primary: orange,
        secondary: blue,
      },
    };
  } else if (APP_NAME === PRODUCT_NAME.DIGITALSAATHI) {
    return {
      palette: {
        primary: {
          '50': '#dff3ed',
          '100': '#b0e0d0',
          '200': '#7dccb3',
          '300': '#47b895',
          '400': '#12a880',
          '500': '#00986d',
          '600': '#008b61',
          '700': '#007b52',
          '800': '#006b45',
          '900': '#004f2b',
          A100: '#b0e0d0',
          A200: '#7dccb3',
          A400: '#12a880',
          A700: '#007b52',
          contrastText: '#fff',
          dark: '#008b61',
          light: '#7dccb3',
          main: '#12a880',
        },
        secondary: {
          '50': '#fde3e6',
          '100': '#fab9c2',
          '200': '#f58c9a',
          '300': '#ee6074',
          '400': '#e64158',
          '500': '#df283e',
          '600': '#cf223e',
          '700': '#bb1b3c',
          '800': '#a8123a',
          '900': '#860236',
          A100: '#fab9c2',
          A200: '#f58c9a',
          A400: '#e64158',
          A700: '#bb1b3c',
          contrastText: '#fff',
          dark: '#860236',
          light: '#cf223e',
          main: '#a8123a',
        },
      },
    };
  } else if (APP_NAME === PRODUCT_NAME.BUYGRO) {
    return {
      palette: {
        primary: {
          '50': '#e5e7f0',
          '100': '#bdc2db',
          '200': '#929bc2',
          '300': '#6975a9',
          '400': '#4a5999',
          '500': '#293f89',
          '600': '#233881',
          '700': '#1a2f76',
          '800': '#12266a',
          '900': '#031654',
          A100: '#bfbedb',
          A200: '#9694c2',
          A400: '#544e99',
          A700: '#2e2075',
          contrastText: '#fff',
          dark: '#031654',
          light: '#1a2f76',
          main: '#031654',
        },
        secondary: {
          '50': '#fef7df',
          '100': '#fceaae',
          '200': '#f9dd7a',
          '300': '#f7d041',
          '400': '#f6c500',
          '500': '#f5bb00',
          '600': '#f6ad00',
          '700': '#f79a00',
          '800': '#f88800',
          '900': '#f96700',
          A100: '#ffcbb8',
          A200: '#ffa98a',
          A400: '#ff6b34',
          A700: '#e84300',
          contrastText: 'rgba(0, 0, 0, 0.87)',
          dark: '#f6ad00',
          light: '#f9dd7a',
          main: '#f6c500',
        },
        utils: {
          favorite: {
            // Generated using createMuiTheme({secondary: amber})
            contrastText: 'rgba(0, 0, 0, 0.87)',
            dark: '#ffab00',
            light: '#ffd740',
            main: '#ffc400',
          },
          success: {
            contrastText: 'rgba(0, 0, 0, 0.87)',
            dark: '#00967f',
            light: '#a9e0d8',
            main: '#09b7a6',
          },
        },
      },
    };
  }

  return {
    palette: {
      primary: blue,
      secondary: pink,
    },
  };
};

export default getTheme();
